import { ColumnMappingBaseTransformPlainObject } from './columnMappingBase.plainObject';
import { ColumnPlainObject } from './column.plainObject';

export class OutputPlainObject extends ColumnMappingBaseTransformPlainObject {
    public columns: ColumnPlainObject[] = [];
}
